// extracted by mini-css-extract-plugin
export default {"center":"DownloadSoftwareBundleHotfixes_center__W9D4N"};